import { seasons } from '../../../mocks/activities';

export default function SeasonalGuide() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Plan Your Visit</p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light">
            Highlands Through<br /><em className="italic">the Seasons</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {seasons.map((s) => (
            <div key={s.season} className="bg-white rounded-2xl p-8">
              <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-jost tracking-widest uppercase mb-6 ${s.colorClass}`}>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${s.icon} text-sm`} />
                </div>
                {s.season}
              </div>
              <p className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-1">{s.season}</p>
              <p className="text-[#9C9890] text-xs font-jost mb-4">{s.months}</p>
              <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{s.highlights}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 bg-[#2D4A3E] rounded-2xl p-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {[
            { value: '125"', label: 'Annual Rainfall', note: 'Most east of the Rockies' },
            { value: '75°F', label: 'Avg. Summer High', note: 'Escaping Southern heat since 1875' },
            { value: '4,118\'', label: 'Elevation', note: 'Highest town in NC' },
          ].map((stat) => (
            <div key={stat.label} className="border-r border-white/15 last:border-0">
              <p className="font-cormorant text-5xl text-white font-light mb-1">{stat.value}</p>
              <p className="text-white/80 text-sm font-jost tracking-widest uppercase mb-1">{stat.label}</p>
              <p className="text-white/45 text-xs font-jost italic">{stat.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}